import { Component, Prop, h } from "@stencil/core";

@Component({
  tag: "f-flyout-footer",
  styleUrl: "f-flyout-footer.scss",
  shadow: true,
})
export class FlyoutFooter {
  @Prop() mode: "primary" | "secondary" = "primary";
  @Prop() label: string;
  @Prop() link: string;

  render() {
    return (
      <div class="flyout-footer__inner" data-test="flyout-footer">
        <div class="flyout-footer__content" data-test="flyout-footer-content">
          {Boolean(this.link) && Boolean(this.label) ? (
            <f-button
              variant={this.mode}
              linkUrl={this.link}
              fullWidth={true}
              data-test="flyout-footer-button"
            >
              {this.label}
            </f-button>
          ) : (
            ""
          )}
          <slot name="flyout-footer-content" />
        </div>
        <slot name="secondary-buttons" />
      </div>
    );
  }
}
